const GET_DETAIL_FABRIC_INVENTORY_BY_ID = 'GET_DETAIL_FABRIC_INVENTORY_BY_ID'
const GET_DETAIL_FABRIC_INVENTORY_BY_ID_SUCCESS = 'GET_DETAIL_FABRIC_INVENTORY_BY_ID_SUCCESS'

const PUT_FABRIC_INVENTORY = 'PUT_FABRIC_INVENTORY'
const PUT_FABRIC_INVENTORY_SUCCESS = 'PUT_FABRIC_INVENTORY_SUCCESS'


const GET_FABRIC_INVENTORY_PAGES = 'GET_FABRIC_INVENTORY_PAGES'
const GET_FABRIC_INVENTORY_PAGES_SUCCESS = 'GET_FABRIC_INVENTORY_PAGES_SUCCESS'

const GET_FABRIC_INVENTORY_DETAIL_PAGES = 'GET_FABRIC_INVENTORY_DETAIL_PAGES'
const GET_FABRIC_INVENTORY_DETAIL_PAGES_SUCCESS = 'GET_FABRIC_INVENTORY_DETAIL_PAGES_SUCCESS'



const FabricInventoryType = {
  GET_DETAIL_FABRIC_INVENTORY_BY_ID,
  GET_DETAIL_FABRIC_INVENTORY_BY_ID_SUCCESS,

  PUT_FABRIC_INVENTORY,
  PUT_FABRIC_INVENTORY_SUCCESS,


  GET_FABRIC_INVENTORY_PAGES,
  GET_FABRIC_INVENTORY_PAGES_SUCCESS,

  GET_FABRIC_INVENTORY_DETAIL_PAGES,
  GET_FABRIC_INVENTORY_DETAIL_PAGES_SUCCESS

}

export default FabricInventoryType
